import { c as _c } from "react/compiler-runtime";
import OnboardingNav from './OnboardingNav';
import CreateOrganization from './CreateOrganization';
const OnboardingView: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><OnboardingNav /><CreateOrganization /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default OnboardingView;